import React from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

function HeadingNavigation() {
  return (
    <div className="menu-bar">
      <NavLink
        to="/"
        className={({ isActive }) => (isActive ? "active-link" : "")}
      >
        Home
      </NavLink>
      <NavLink
        to="/productsCycles"
        className={({ isActive }) => (isActive ? "active-link" : "")}
      >
        Cycles
      </NavLink>
      <NavLink
        to="/productsCars"
        className={({ isActive }) => (isActive ? "active-link" : "")}
      >
        Cars
      </NavLink>
      <NavLink
        to="/productsToys"
        className={({ isActive }) => (isActive ? "active-link" : "")}
      >
        Toys
      </NavLink>
      <NavLink
        to="/productsBikes"
        className={({ isActive }) => (isActive ? "active-link" : "")}
      >
        Bikes
      </NavLink>
      <NavLink
        to="/productsGiftsAndArts"
        className={({ isActive }) => (isActive ? "active-link" : "")}
      >
        Gifts/Arts
      </NavLink>
    </div>
  );
}

export default HeadingNavigation;
